// src/pages/Profile/components/NewsTab.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
 
/* ── Small inline logo loader ── */
const MiniLogoLoader = ({ label }) => (
  <div className="mini-loader-wrap">
    <div className="mini-logo">
      <div className="mini-bar-wrap mini-bar-left">
        <div className="mini-bar-fill mini-fill-left" />
      </div>
      <div className="mini-bar-wrap mini-bar-center">
        <div className="mini-bar-fill mini-fill-center" />
      </div>
      <div className="mini-bar-wrap mini-bar-right">
        <div className="mini-bar-fill mini-fill-right" />
      </div>
    </div>
    {label && <p className="mini-loader-label">{label}</p>}
  </div>
);
 
const NewsTab = ({ news, loading, error }) => {
  const navigate = useNavigate();
 
  const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
 
    if (diffHours < 1) return 'Just now';
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
    return date.toLocaleDateString();
  };
 
  // Function to handle news click
  const handleNewsClick = (article) => {
    // Navigate to news detail page
    navigate(`/news/${article.slug}`);
  };
 
  return (
    <div className="profile-tab-content">
      <div className="tab-header">
        <span className="tab-icon">📰</span>
        <h2>Market News</h2>
      </div>
 
      {loading ? (
        <div className="loading-state">
          <MiniLogoLoader label="Loading news..." />
        </div>
      ) : error ? (
        <div className="error-state">{error}</div>
      ) : news.length === 0 ? (
        <div className="empty-state">
          <p>No news available</p>
        </div>
      ) : (
        <div className="news-list">
          {news.map((article) => (
            <div 
              key={article.id} 
              className="news-card"
              onClick={() => handleNewsClick(article)}
            >
              <div className="news-left">
                <div className="news-info">
                  <h3 className="news-item-title">{article.title}</h3>
                  <p className="news-item-summary">{article.summary}</p>
                </div>
              </div>
              <div className="news-right">
                <span className="news-time">
                  {formatTimeAgo(article.published_at || article.created_at)}
                </span>
                {article.category_name && (
                  <span className="news-category">{article.category_name}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
 
export default NewsTab;